/* Quem é o escritório, em um lugar só.

   Estava dentro de procuracao.js, que importa o jsPDF. As telas do cliente
   (tira-dúvidas, autocadastro) precisam do nome, da OAB e do WhatsApp, e se
   fossem buscar lá arrastariam 380 kB para um pacote de 4 kB. Este módulo não
   importa nada, de propósito: ele é usado pelo painel, pelo portal e pelo PDF.

   O WhatsApp entra no link wa.me, que exige só dígitos com o código do país. */

export const ADVOGADO = {
  nome:     "FRANCISCO BENÍCIO PONTES NETO",
  oab:      "OAB/AP 1726",
  endereco: "Avenida Pedro Baião, 854, bairro do Trem, Macapá/AP",
  whatsapp: "(96) 98139-3271"   // vazio esconde o número do rodapé e o botão
};

/* O mesmo número no formato que o WhatsApp aceita: 55 + DDD + linha. */
export const whatsappLink = texto => {
  const d = ADVOGADO.whatsapp.replace(/\D/g, "");
  if (!d) return "";
  return `https://wa.me/55${d}${texto ? "?text=" + encodeURIComponent(texto) : ""}`;
};
